import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  content: {
    '& > div + div': {
      marginTop: theme.spacing(2),
    },
  },
  viewItem: {
    boxShadow: 'none',
    padding: `${theme.spacing(0.5)} 0 !important`,
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  errorBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
}));
